import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";

const faqData = [
  {
    question: "What are refurbished laptops?",
    answer:
      "Pre-owned laptops that are tested, repaired, and certified to work like new.",
  },
  {
    question: "Do they come with warranty?",
    answer:
      "Yes, usually 3–6 months warranty is provided.",
  },
  {
    question: "Are they reliable?",
    answer:
      "Yes, all devices go through strict quality checks.",
  },
  {
    question: "Can I return it?",
    answer:
      "We offer 7-day easy return policy.",
  },
  {
    question: "Battery condition?",
    answer:
      "Battery health is generally 70–90%.",
  },
];

const Faq = () => {
  const [active, setActive] = useState(null);

  const toggle = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <div className="bg-gradient-to-b from-gray-100 via-gray-150 to-gray-50 py-4 px-3">

      {/* HEADER */}
      <div className="text-center mb-5">
        <h2 className="text-xl md:text-2xl font-semibold text-gray-800">
          FAQs
        </h2>
        <p className="text-gray-500 text-xs mt-1">
          Quick answers about refurbished laptops 💻
        </p>
      </div>

      {/* FAQ LIST */}
      <div className="max-w-2xl mx-auto space-y-2">

        {faqData.map((item, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden"
          >

            {/* QUESTION */}
            <button
              onClick={() => toggle(index)}
              className="w-full flex justify-between items-center px-3 py-2"
            >
              <span className="text-sm font-medium text-gray-800 text-left">
                {item.question}
              </span>

              <motion.span
                animate={{ rotate: active === index ? 180 : 0 }}
                className="text-xs"
              >
                <FaChevronDown />
              </motion.span>
            </button>

            {/* ANSWER */}
            <AnimatePresence>
              {active === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  className="px-3 pb-2 text-gray-600 text-xs leading-relaxed"
                >
                  {item.answer}
                </motion.div>
              )}
            </AnimatePresence>

          </div>
        ))}

      </div>
    </div>
  );
};

export default Faq;